// @bzapper/sdk — cliente tipado do bZapper. Tipos GERADOS do OpenAPI (fonte única).
// Regenerar: pnpm --filter @bzapper/sdk generate
import createClient, { type ClientOptions } from 'openapi-fetch';
import type { paths } from './generated/types.ts';

export type { paths } from './generated/types.ts';
export type { components } from './generated/types.ts';

export interface BBuzzClientOptions extends ClientOptions {
  /** Base da API (ex.: https://api.bzapper.example). */
  baseUrl: string;
  /** API key do tenant — vira `Authorization: Bearer <apiKey>`. */
  apiKey?: string;
  /** Locale BCP-47 padrão para `Accept-Language`. */
  locale?: string;
}

/** Cria um cliente tipado do bZapper a partir do OpenAPI. */
export function createBBuzzClient({ apiKey, locale, headers, ...opts }: BBuzzClientOptions) {
  return createClient<paths>({
    ...opts,
    headers: {
      ...(apiKey ? { Authorization: `Bearer ${apiKey}` } : {}),
      ...(locale ? { 'Accept-Language': locale } : {}),
      ...headers,
    },
  });
}

export type BBuzzClient = ReturnType<typeof createBBuzzClient>;
